import { useContext } from 'react';
import { ReactFlowProvider } from 'reactflow';
import { FlowBuilderProvider } from './FlowBuilderProvider';
import { FlowBuilderContext } from './context';
import { Flow } from './Flow';
import Loader from '__components/Kizen/Loader';
import { FlowBar } from './styles';
import { ControlBar } from './ControlBar';
import { FlowScrollContainer } from 'ts-components/AutomationEngine/FlowScrollContainer';
import { useNavBarState } from '__app/navBarController';
import { Wrapper } from 'pages/AutomationEngine/styles';
import { UploadRelatedObjectModal } from './UploadRelatedObjectModal';
import ConfirmNavigationModal from '__components/Modals/presets/ConfirmNavigation';
import { AdditionalVariablesModal } from './AdditioanalVariablesModal';
import { NODE_TYPES } from 'pages/AutomationEngine/Engine/Flow/conatants';
import { DeactivationModal } from '../../../components/DeactivationModal';
import { RunSmartConnectorStepModal } from './RunSmartConnectorStepModal';

export const FlowBuilderView = () => {
  const { height } = useNavBarState();

  const {
    smartConnectorLoading,
    setInteracting,
    droppedStep,
    isDirty,
    deactivationModalProps,
  } = useContext(FlowBuilderContext);

  return (
    <>
      <Wrapper navHeight={height} className="wrapper">
        <ControlBar className="ControlBar" />
        <FlowBar />
        <Loader loading={smartConnectorLoading}>
          <FlowScrollContainer setInteracting={setInteracting}>
            <Flow />
          </FlowScrollContainer>
        </Loader>
      </Wrapper>
      {droppedStep?.step.type === NODE_TYPES.upload ? (
        <UploadRelatedObjectModal index={droppedStep.index} />
      ) : null}
      {droppedStep?.step.type ===
      NODE_TYPES.connection_initialize_additional_variables ? (
        <AdditionalVariablesModal />
      ) : null}
      {droppedStep?.step.type === NODE_TYPES.runSmartConnector &&
      droppedStep.step.order === droppedStep.index ? (
        <RunSmartConnectorStepModal />
      ) : null}
      <ConfirmNavigationModal when={isDirty} />
      <DeactivationModal {...deactivationModalProps} />
    </>
  );
};

export const FlowBuilder = () => {
  return (
    <ReactFlowProvider>
      <FlowBuilderProvider>
        <FlowBuilderView />
      </FlowBuilderProvider>
    </ReactFlowProvider>
  );
};
